import { Observable } from 'rxjs';

import { Pagination } from '../pagination';
import { Candidate, CandidateAdapter } from './candidate';
import { Job } from './job';

export enum HiringManagerAggregationLabels {
  SUBMITTED = 'submitted',
  ADVANCED = 'advanced',
  REJECTED = 'rejected',
}

export interface Aggregations extends AbstractAggregation {
  totalMatches: number;
  hotCandidates: number;
  newMatches: number;
}

export interface HiringManagerAggregation extends AbstractAggregation<Candidate> {
  submitted: number;
  advanced: number;
  rejected: number;
}

export interface AbstractAggregation<T = CandidateAdapter> {
  jobId?: number;
  candidates?: Pagination<T>;
  isLoaded?: boolean;
}

export interface AggregatedJobData extends AbstractAggregation {
  totalDirect: number;
  inReviewDirect: number;
  shortlisted: number;
  rejected: number;
  passive: number;
  passiveWarm: number;
  passiveHot: number;
  referrals: number;
}

export interface JobWithAggregations extends Job {
  aggregation$: Observable<AbstractAggregation>;
}
